import { VARIANT_LIVE_EVENT } from '@/components/CharacterGenerator/constants/variantIdList'

const COLUMN_WITHOUT_EVENTS = 1
const EVENT_PER_COLUMN_COEF = 8

export default character => COLUMN_WITHOUT_EVENTS + Math.ceil(character[VARIANT_LIVE_EVENT].length / EVENT_PER_COLUMN_COEF)
